module.exports = __webpack_public_path__ + "722f870e8bebd1b67349f31ec40992d7.svg";